import { Dropdown, Form } from "react-bootstrap";
import { FaMoon, FaSun, FaPalette, FaSignOutAlt } from "react-icons/fa";
import { useTheme } from "../../APIHelpers/ThemeContext";
import { plateformSettingServices } from "../../APIServices/GlobalManagements/plateformSettingServices";
import { authServices } from "../../APIServices/UserData/authServices";
import { FaCircleHalfStroke } from "react-icons/fa6";
import UseToggle from "../../Hooks/UseToggle";
import CustomizeThemeColors from "./CustomizeThemeColors";
import SoundNotificationSettings from "./SoundNotificationSettings";

const UserProfileMenu = ({ setOpenModule, currentUserData, getSinglePlateformSettings, plateformSettings }) => {
  const { theme, setThemeMode } = useTheme();
  const toggles = UseToggle();

  const addUpdatePlateformSettings = async (type, value) => {
    let userData = {}
    userData[type] = value
    userData.type = type
    let data = await plateformSettingServices.addUpdatePlateformSettings(userData)
    if (data?.statusCode === 200) {
      getSinglePlateformSettings()
    }
  }

  const logout = async () => {
    await authServices.logout()
  }

  return (
    <>
      <Dropdown.Menu
        align="end"
        className="profile-menu shadow"
        style={{ width: 260 }}
      >
        {/* Header */}
        <div className="px-3 py-3 border-bottom" onClick={() => setOpenModule("profileManagement")}>
          <h6 className="fw-semibold mb-1">{currentUserData?.name}</h6>
          <small className="text-muted cursor-pointer">Manage Account</small>
        </div>

        {/* Status */}
        <div className="px-3 py-2 border-bottom d-flex align-items-center">
          <span className="status-dot online" />
          <small className="ms-2 fw-medium">Online</small>
        </div>

        {/* Preferences */}
        <div className="px-3 py-3 border-bottom">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <small>Desktop notifications</small>
            <Form.Check
              type="switch"
              checked={!!plateformSettings?.desktopNotification}
              onChange={() => addUpdatePlateformSettings("desktopNotification", !plateformSettings?.desktopNotification)}
            />
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <small>Sound notifications</small>
            <Form.Check
              type="switch"
              checked={!!plateformSettings?.soundNotification}
              onChange={() => addUpdatePlateformSettings("soundNotification", !plateformSettings?.soundNotification)}
            />
          </div>
        </div>

        {/* Theme */}
        <div className="px-3 py-3 border-bottom">
          <small className="d-block mb-2 text-muted">Theme</small>
          <div className="d-flex gap-2">
            <button
              className="theme-btn"
              onClick={() => { setThemeMode("light"); addUpdatePlateformSettings("themeSettings", "light") }}
              title="Light Mode"
              style={{
                backgroundColor: theme === "light" ? "var(--primary)" : "var(--button-bg)",
                color: theme === "light" ? "white" : "var(--text-primary)",
                border: `2px solid ${theme === "light" ? "var(--primary)" : "var(--border-color)"}`,
              }}
            >
              <FaSun />
            </button>
            <button
              className="theme-btn"
              onClick={() => { setThemeMode("dark"); addUpdatePlateformSettings("themeSettings", "dark") }}
              title="Dark Mode"
              style={{
                backgroundColor: theme === "dark" ? "var(--primary)" : "var(--button-bg)",
                color: theme === "dark" ? "white" : "var(--text-primary)",
                border: `2px solid ${theme === "dark" ? "var(--primary)" : "var(--border-color)"}`,
              }}
            >
              <FaMoon />
            </button>
            <button
              className="theme-btn"
              onClick={() => { setThemeMode("auto"); addUpdatePlateformSettings("themeSettings", "auto") }}
              title="Auto Mode"
              style={{
                backgroundColor: theme === "dark" ? "var(--primary)" : "var(--button-bg)",
                color: theme === "dark" ? "white" : "var(--text-primary)",
                border: `2px solid ${theme === "dark" ? "var(--primary)" : "var(--border-color)"}`,
              }}
            >
              <FaCircleHalfStroke />
            </button>
            <button
              className="theme-btn"
              title="Custom Theme"
              onClick={() => toggles.setToggle()}
              style={{
                backgroundColor: "var(--button-bg)",
                color: "var(--text-primary)",
                border: "2px solid var(--border-color)",
              }}
            >
              <FaPalette />
            </button>
          </div>
        </div>
        <Dropdown.Item className="menu-item" onClick={() => toggles.setToggle1()}>Sound & Notification</Dropdown.Item>
        <Dropdown.Item className="menu-item">Help Center</Dropdown.Item>
        <Dropdown.Item className="menu-item">Community</Dropdown.Item>

        <Dropdown.Divider />
        <Dropdown.Item className="menu-item text-danger" onClick={logout}>
          <FaSignOutAlt className="me-2" />
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
      <CustomizeThemeColors
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        plateformSettings={plateformSettings}
        Title={`Customize Theme Colors`}
      />
      <SoundNotificationSettings
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        plateformSettings={plateformSettings}
        addUpdatePlateformSettings={addUpdatePlateformSettings}
        Title={`Manage Sounds & Notifications`}
      />
    </>
  );
};

export default UserProfileMenu;
